import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect, useState } from 'react'
import Footer from '../../molecules/footer/footer'
import Header from '../../molecules/header/header'
import Chat from '../../atoms/chat/chat'
import ModalChat from '../../modals/modal-chat/modal-chat'
import ChatButton from '../../atoms/chat-button/chat-button'
import CookieConsent from '../../molecules/cookie-consent/cookie-consent'
import Logo from '../../../assets/images/logo/512-512.png'
import './layout.scss'
import SocialMedia from '../../atoms/social-media/social-media'
import useMediaQuery from '../../../utils/useMediaQuery'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import UserSession from '../../../hooks/userSession'

const Layout = props => {
  const resultQuery = useStaticQuery(
    graphql`
      query NAV_CHAT_BUTTON_QUERY {
        allContentfulVConfidentTransversal(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            tieneChat
            codigoIcu
          }
        }
      }
    `
  )
  const isMobile = useMediaQuery()

  const [commondModal, setCommondModal] = useState(null)
  const haveChat = resultQuery.allContentfulVConfidentTransversal.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0]?.tieneChat || false

  const pageViewDataLayer = () => {
    let location = ''
    const userInfo = UserSession.getUserInfo()
  
    if (typeof window !== 'undefined') {
      location = window.location.href
    }
    const CryptoJS = require("crypto-js");
    function encrypt(data) {
      if (data) {
        data = CryptoJS.SHA256(data);
        data = data.toString();
        return data;
      } else {
        return undefined
      }
    }
    pushDataLayerEvent({
      event: 'Page_View',
      location: location,
      page: location.split('/').slice(3).join('/'),
      title: props.title || undefined,
      userId: userInfo ? userInfo.userId ? encrypt(userInfo.userId.toString()) : userInfo.usuarioId ? encrypt(userInfo.usuarioId.toString()) : undefined : undefined
    })
  }

  useEffect(() => {
    pageViewDataLayer()
  }, [])

  // inicio dataLayer content_consumption
  const dataLayerContentConsumption = initialTime => {
    let endTime = ''
    let location = ''
    if (typeof window !== 'undefined') {
      location = window.location.href
      endTime = (window.performance.now() - initialTime) / 1000
    }
    if (endTime > 60 && scrollFlag50 === false) {
      pushDataLayerEvent({
        event: 'content_consumption',
      })
    }
  }

  let scrollFlag50 = true
  const handleScroll = () => {
    const scrollPercentage =
      (document.documentElement.scrollTop /
        (document.documentElement.scrollHeight -
          document.documentElement.clientHeight)) *
      100
    if (scrollFlag50 && scrollPercentage >= 50) {
      scrollFlag50 = false
    }
  }

  let initialTime = ''
  useEffect(() => {
    if (typeof window !== 'undefined') {
      initialTime = window.performance.now()
      window.addEventListener('beforeunload', () => {
        dataLayerContentConsumption(initialTime)
      })
      window.addEventListener('scroll', () => {
        handleScroll()
      })
    }
  }, [])

  // fin dataLayer content_consumption

  return (
    <>
      <Header isMobile={isMobile} />
      {commondModal}
      <div>
        <main>{props.children}</main>
        <SocialMedia />

        {/* <Chat /> */}
        {(process.env.LOCALE === 'es-CO') && <ModalChat />}

        {process.env.ENVIRONMENT !== 'PDN' && (
          <span className="f-country-watermark">
            {process.env.COUNTRY_NAME + ' - ' + process.env.ENVIRONMENT}
          </span>
        )}
        {/* <CookieConsent logoUrl={Logo} /> */}
        {haveChat && process.env.LOCALE !== "es-CO" && (
          <ChatButton mobile={props.mobile} />
        )}
        <Footer setCommondModal={setCommondModal} isMobile={isMobile} />
      </div>
    </>
  )
}

export default Layout
